// Mock data for JobGenie.in

export const featuredJobs = [
  {
    id: 1,
    title: "Senior Software Engineer",
    company: "TCS",
    experience: "5-8 years",
    salary: "₹12-18 LPA",
    location: "Bangalore",
    skills: ["React", "Node.js", "MongoDB"],
    postedDays: 2,
    applicants: 45,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583873.gif",
    jobType: "Full Time",
    description: "Looking for experienced software engineer with strong background in full-stack development."
  },
  {
    id: 2,
    title: "Frontend Developer",
    company: "Infosys",
    experience: "3-5 years",
    salary: "₹8-12 LPA",
    location: "Pune",
    skills: ["React", "JavaScript", "CSS"],
    postedDays: 1,
    applicants: 67,
    logo: "https://img.naukimg.com/logo_images/groups/v1/44066.gif",
    jobType: "Full Time",
    description: "Seeking talented frontend developer to join our digital transformation team."
  },
  {
    id: 3,
    title: "Data Scientist",
    company: "Wipro",
    experience: "4-7 years",
    salary: "₹15-22 LPA",
    location: "Hyderabad",
    skills: ["Python", "Machine Learning", "SQL"],
    postedDays: 3,
    applicants: 89,
    logo: "https://img.naukimg.com/logo_images/groups/v1/66189.gif",
    jobType: "Full Time",
    description: "Join our analytics team to work on cutting-edge AI/ML projects."
  },
  {
    id: 4,
    title: "Full Stack Developer",
    company: "Accenture",
    experience: "2-4 years",
    salary: "₹6-10 LPA",
    location: "Mumbai",
    skills: ["Java", "Spring Boot", "Angular"],
    postedDays: 4,
    applicants: 120,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583853.gif",
    jobType: "Full Time",
    description: "Develop and maintain enterprise applications for global clients."
  },
  {
    id: 5,
    title: "DevOps Engineer",
    company: "HCL Technologies",
    experience: "3-6 years",
    salary: "₹10-16 LPA",
    location: "Noida",
    skills: ["AWS", "Docker", "Kubernetes"],
    postedDays: 1,
    applicants: 34,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583729.gif",
    jobType: "Full Time",
    description: "Manage cloud infrastructure and implement CI/CD pipelines."
  },
  {
    id: 6,
    title: "Product Manager",
    company: "Amazon",
    experience: "5-8 years",
    salary: "₹25-35 LPA",
    location: "Bangalore",
    skills: ["Product Strategy", "Agile", "Analytics"],
    postedDays: 2,
    applicants: 156,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583641.gif",
    jobType: "Full Time",
    description: "Lead product development for our e-commerce platform."
  },
  {
    id: 7,
    title: "UI/UX Designer",
    company: "Flipkart",
    experience: "2-5 years",
    salary: "₹8-14 LPA",
    location: "Bangalore",
    skills: ["Figma", "User Research", "Prototyping"],
    postedDays: 5,
    applicants: 78,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583605.gif",
    jobType: "Full Time",
    description: "Design intuitive user experiences for millions of users."
  },
  {
    id: 8,
    title: "Backend Developer",
    company: "Google",
    experience: "4-7 years",
    salary: "₹30-45 LPA",
    location: "Gurgaon",
    skills: ["Go", "Microservices", "PostgreSQL"],
    postedDays: 1,
    applicants: 234,
    logo: "https://img.naukimg.com/logo_images/groups/v1/4583609.gif",
    jobType: "Full Time",
    description: "Build scalable backend systems for global products."
  }
];

export const topCompanies = [
  { id: 1, name: "TCS", logo: "https://img.naukimg.com/logo_images/groups/v1/4583873.gif", jobs: 2500 },
  { id: 2, name: "Infosys", logo: "https://img.naukimg.com/logo_images/groups/v1/44066.gif", jobs: 1800 },
  { id: 3, name: "Wipro", logo: "https://img.naukimg.com/logo_images/groups/v1/66189.gif", jobs: 1600 },
  { id: 4, name: "Accenture", logo: "https://img.naukimg.com/logo_images/groups/v1/4583853.gif", jobs: 1400 },
  { id: 5, name: "HCL", logo: "https://img.naukimg.com/logo_images/groups/v1/4583729.gif", jobs: 1200 },
  { id: 6, name: "Amazon", logo: "https://img.naukimg.com/logo_images/groups/v1/4583641.gif", jobs: 980 },
  { id: 7, name: "Flipkart", logo: "https://img.naukimg.com/logo_images/groups/v1/4583605.gif", jobs: 750 },
  { id: 8, name: "Google", logo: "https://img.naukimg.com/logo_images/groups/v1/4583609.gif", jobs: 650 },
  { id: 9, name: "Microsoft", logo: "https://img.naukimg.com/logo_images/groups/v1/4583617.gif", jobs: 580 },
  { id: 10, name: "IBM", logo: "https://img.naukimg.com/logo_images/groups/v1/4583733.gif", jobs: 520 }
];

export const jobCategories = [
  { id: 1, name: "IT / Software", count: 25000, icon: "Code" },
  { id: 2, name: "Sales / Marketing", count: 18000, icon: "TrendingUp" },
  { id: 3, name: "Finance / Accounting", count: 12000, icon: "DollarSign" },
  { id: 4, name: "HR / Admin", count: 8500, icon: "Users" },
  { id: 5, name: "Engineering", count: 15000, icon: "Settings" },
  { id: 6, name: "Healthcare", count: 9000, icon: "Heart" },
  { id: 7, name: "Design / Creative", count: 6500, icon: "Palette" },
  { id: 8, name: "Operations", count: 7200, icon: "Package" }
];

export const topLocations = [
  { id: 1, name: "Bangalore", count: 35000 },
  { id: 2, name: "Mumbai", count: 28000 },
  { id: 3, name: "Delhi / NCR", count: 32000 },
  { id: 4, name: "Hyderabad", count: 22000 },
  { id: 5, name: "Pune", count: 18000 },
  { id: 6, name: "Chennai", count: 16000 },
  { id: 7, name: "Kolkata", count: 12000 },
  { id: 8, name: "Ahmedabad", count: 10000 }
];

export const experienceLevels = [
  "Fresher",
  "0-1 years",
  "1-3 years",
  "3-5 years",
  "5-7 years",
  "7-10 years",
  "10+ years"
];

export const quickLinks = {
  jobSeekers: [
    "Search Jobs",
    "Browse Jobs",
    "Browse Companies",
    "Job Search App",
    "Free Job Alerts",
    "Job Search by Designation",
    "Job Search by Location",
    "Job Search by Skill",
    "Job Search by Company"
  ],
  employers: [
    "Buy Online",
    "Product & Pricing",
    "Post a Job",
    "Search Resume Database",
    "Recruiter Login",
    "Hiring Solutions",
    "Sales Enquiry"
  ],
  about: [
    "About Us",
    "Careers",
    "Contact Us",
    "Summons/Notices",
    "Grievances",
    "Report an Issue",
    "Privacy Policy",
    "Terms & Conditions",
    "Trust & Safety"
  ]
};